import { defineStore } from 'pinia'
import { ref, Ref } from 'vue'
import ApiService from '@/utils/ApiService'
import messages from '@/utils/messages'
import { CONST_INSTITUTIONAL_STATUS } from '@/static/constantsInstitutional'
import { useRedeSubredeStore } from '@/stores/redeSubredeStore'
import { usePCStore } from '@/stores/pcStore'
import { TelasInstitucionaisModel } from '@/models/TelasInstitucionaisModel'
import axios from 'axios'

//import { getErrorMessage, showApiError } from '@/utils/errorHandler';

/* =======================
 * INTERFACES
 * ======================= */

// institutionalStore.ts
export interface InstitutionalFilter {
  nome?: string
  status?: number
  perfil?: string
  telasCadastradas?: string          // ✅ INICIAL | AGUARDE | ABERTURA
  codSubrede?: number[]   // ✅ subrede da rede 10
  dt_ini_vigencia?: string
  dt_fim_vigencia?: string
  //telasCadastradas?: string 
 // codSubrede?: number 
  granularidade?: string  
}

export interface InstitutionalImage {
  posicaoImagem: number
  urlS3: string
  duracaoImagem?: number
}

export interface redeInterface {
  codRede: number
  codSubrede: number
}


export interface InstitutionalScreen {
  id: number
  nome: string
  dtIniVigencia: string
  dtFimVigencia?: string
  status: number
  perfil: string
  versao: number
  exibeTelaAbertura: boolean
  telasCadastradas: string

  corTexto?: string | null

  imagens?: InstitutionalImage[]
  redes?: Array<redeInterface>

  pcsIds 												: Array<number | undefined>;
  pcs?   :   Array<pcInterface>

}

export interface pcInterface {
	codpontocaptura						: number | undefined;
	nompontocaptura						: string | undefined;
	ufredeautoatndto					: string | undefined;
	nomcidredeautoatndto			: string | undefined;
	nomsegmmerclocalptoatndto	: string | undefined;
	nomsubredeautoatndto			: string | undefined;
	nomtpmaqautoatndto				: string | undefined | null;
};

export interface InstitutionalDraft {
  id?: number
  nome: string
  perfil: string | null
  dtIniVigencia: string
  dtFimVigencia?: string
  corTexto?: string | null
  exibeTelaAbertura?: boolean
}

/* =======================
 * STORE
 * ======================= */

const alterarTelaInicial = ref(false)
const alterarTelaAguarde = ref(false)
const alterarTelaAbertura = ref(true)

const institutionalEditData = ref<any>(null)

const setInstitutionalEditData = (data: any) => {
  institutionalEditData.value = data
}

const clearInstitutionalEditData = () => {
  institutionalEditData.value = null
}
export const useInstitutionalStore = defineStore('institutional', () => {
  const institutionalScreens: Ref<InstitutionalScreen[]> = ref([])
  const institutionalDetail: Ref<TelasInstitucionaisModel | null> = ref(null)

  const institutionalDraft: Ref<InstitutionalDraft> = ref({
    nome: '',
    perfil: null,
    dtIniVigencia: '',
    dtFimVigencia: ''
  })

  const selectedInstitutionals: Ref<InstitutionalScreen[]> = ref([])
  const institutionalFilter: Ref<InstitutionalFilter> = ref({})
  const loading = ref(false)

  /* =======================
   * HELPERS
   * ======================= */

  
const formatDateToBackend = (date?: string) => {
  if (!date) return date;

  // converte DD/MM/YYYY → YYYY-MM-DD
  if (date.includes('/')) {
    const [day, month, year] = date.split('/');
    return `${year}-${month}-${day}`;
  }

  return date;
};

/*const buildInstitutionalPayload = (detail: TelasInstitucionaisModel) => {
  return {
    id: detail.id,
    nome: detail.nome,
    perfil: detail.perfil,
    dtIniVigencia: formatDateToBackend(detail.dtIniVigencia),
    dtFimVigencia: formatDateToBackend(detail.dtFimVigencia),
    versao: detail.versao,
    telasCadastradas: detail.telasCadastradas,
    exibeTelaAbertura: detail.exibeTelaAbertura,
    comentarioAjuste: detail.comentarioAjuste, 

    // ✅ mantém direto
    redes: detail.redes || [],

    // ✅ CONVERSÃO IMPORTANTE
    pcsIds: detail.pcsIds?.length
      ? detail.pcsIds
      : detail.pcs?.map(pc => pc.codpontocaptura) || [],

    imagens: detail.imagens || []
  };
};*/

const buildInstitutionalPayload = (
  detail: TelasInstitucionaisModel,
  imagens: any[] = [],
  telas: any[] = []
) => {
  const pcStore = usePCStore()
  const redeSubredeStore = useRedeSubredeStore()

  const imagensPayload = imagens.map(img => ({
    posicaoImagem: img.posicaoImagem,
    urlS3: img.urlS3,
    duracaoImagem: img.duracaoImagem,
    hashImagem: img.hashImagem || null,
    dataCriacao: new Date().toISOString()
  }))

  // ✅ converte array → string igual o toPayload() faz
  const telasCadastradasString = Array.isArray(telas) && telas.length
    ? telas.map((t: any) => t.tipoTela ?? t).join(',')
    : Array.isArray(detail.telasCadastradas) && detail.telasCadastradas.length
      ? detail.telasCadastradas.map((t: any) => t.tipoTela ?? t).join(',')
      : null

  return {
    id: detail.id,
    nome: detail.nome,
    perfil: detail.perfil || null,
    dtIniVigencia: formatDateToBackend(detail.dtIniVigencia),
    dtFimVigencia: formatDateToBackend(detail.dtFimVigencia),
    versao: detail.versao,

    redes: detail.redes || [],
    pcsIds: pcStore.selectedPCs.map(pc => pc.codpontocaptura),

    imagens: imagensPayload,

    telasCadastradas: telasCadastradasString, // ✅ sempre string ou null
    exibeTelaAbertura: detail.exibeTelaAbertura ?? false
  }
}



  const formatDateToApi = (date: string) => {
    const [day, month, year] = date.split('/')
    return `${year}-${month}-${day}`
  }


const fetchPcsByIds = async (ids: number[]): Promise<any[]> => {
  try {
    loading.value = true

    const idsString = ids.map(id => String(id))

    const response = await ApiService.post<any[]>(
      process.env.VUE_APP_API_CAMPAIGN_ENDPOINT,
      process.env.VUE_APP_API_CAMPAIGN_ROUTE_POST_PCS_EXISTING,
      idsString
    )

    return response || []
  } catch (error) {
    console.error('Erro ao buscar PCs por IDs', error)
    return []
  } finally {
    loading.value = false
  }
}

  /* =======================
   * LISTAGEM
   * ======================= */

  const fetchInstitutionalScreens = async () => {
    try {
      loading.value = true

      const response = await ApiService.get<InstitutionalScreen[]>(
        process.env.VUE_APP_API_CAMPAIGN_ENDPOINT,
        process.env.VUE_APP_API_INSTITUTIONAL_ROUTE_GET_LIST,
        institutionalFilter.value
      )

      institutionalScreens.value = Array.isArray(response) ? response : []
    } catch (error) {
      console.error(error)
      messages.showErrorMsg('Erro ao buscar cadastros institucionais.')
    } finally {
      loading.value = false
    }
  }

  /* =======================
   * VISUALIZAR
   * ======================= */

  const fetchInstitutionalById = async (id: number) => {
  try {
    loading.value = true

    const response = await ApiService.get<InstitutionalScreen>(
      process.env.VUE_APP_API_CAMPAIGN_ENDPOINT,
      `${process.env.VUE_APP_API_INSTITUTIONAL_ROUTE_GET_BY_ID}/${id}`
    )

    console.log('[STORE] response do backend:', response)

    if (response) {
      const model = new TelasInstitucionaisModel(response)

      if (model.dtIniVigencia?.includes('-')) {
        model.dtIniVigencia = model.dtIniVigencia.split('-').reverse().join('/')
      }
      if (model.dtFimVigencia?.includes('-')) {
        model.dtFimVigencia = model.dtFimVigencia.split('-').reverse().join('/')
      }

      institutionalDetail.value = model

      alterarTelaInicial.value  = model.alterarTelaInicial ?? false
      alterarTelaAguarde.value  = model.alterarTelaAguarde ?? false
      alterarTelaAbertura.value = model.alterarTelaAbertura ?? false


      // ✅ sincroniza imagens
      if (model.imagens?.length) {
        imagensDraft.value = model.imagens.map(img => ({
          posicaoImagem: img.posicaoImagem,
          urlS3: img.urlS3,
          duracaoImagem: img.duracaoImagem ?? 5,
          file: null
        }))
      } else {
        imagensDraft.value = []
      }

      // ✅ sincroniza telas
      if (model.telasCadastradas?.length) {
        telasDraft.value = [...model.telasCadastradas]
      } else {
        telasDraft.value = []
      }

      // ✅ sincroniza exibeTelaAbertura
      exibeTelaAberturaRascunho.value = model.exibeTelaAbertura ?? false

      // ✅ sincroniza redes no redeSubredeStore
      if (model.redes?.length) {
        const redeSubredeStore = useRedeSubredeStore()
        await redeSubredeStore.setSelecionadasFromBackend(model.redes)
      }

      // ✅ sincroniza PCs no pcStore
      if (model.pcsIds?.length) {
        const pcStore = usePCStore()
        pcStore.selectedPCs = (model.pcs || []) as any[]
      }

    } else {
      institutionalDetail.value = null
    }

  } catch (error) {
    console.error(error)
    messages.showErrorMsg('Erro ao visualizar cadastro institucional.')
  } finally {
    loading.value = false
  }
}



  /* =======================
  * CRIAÇÃO
  * ======================= */

  /* =======================
* CRIAÇÃO / SALVAR RASCUNHO
* ======================= */


const createInstitutional = async (
  imagens: any[] = [],
  telas: any[] = [],
  exibeTelaAbertura: boolean,
  corTexto: string | null,
  isSavingDraft = false
) => {
  try {

     console.log('🔍 telas recebidas no createInstitutional:', telas) // ← ADICIONE
    const pcStore = usePCStore();
    const redeSubredeStore = useRedeSubredeStore();

    let model = institutionalDetail.value;

    // ✅ CASO NOVO → cria model a partir do draft
    if (!model) {
      model = new TelasInstitucionaisModel({
        ...institutionalDraft.value,
        versao: 1
      });
    }

    const { nome, perfil, dtIniVigencia } = model;

    // ✅ validação (igual você já tinha)
    if (isSavingDraft) {
      if (!nome) {
        messages.showErrorMsg('Preencha o campo Nome para salvar.');
        return null;
      }
    } else {
      if (!nome || !perfil || !dtIniVigencia) {
        messages.showErrorMsg('Preencha os campos obrigatórios.');
        return null;
      }
    }

    if (!isSavingDraft && !redeSubredeStore.subredesSelecionadas.length) {
      messages.showErrorMsg('Selecione ao menos uma Subrede.');
      return null;
    }

    // ✅ MONTAR DADOS NO MODEL (igual campanhas faz)
    model.imagens = imagens;

    model.telasCadastradas = telas;

    model.exibeTelaAbertura = exibeTelaAbertura;

    model.redes = redeSubredeStore.subredesSelecionadas.map(sr => ({
      codRede: 10,
      codSubrede: sr.codSubredeAutoAtndto
    }));

    model.pcsIds = pcStore.selectedPCs.map(pc => pc.codpontocaptura);

    model.status = CONST_INSTITUTIONAL_STATUS.DRAFT.id;

    console.log('Payload enviado ao backend:', model.toPayload());

    model.alterarTelaInicial  = alterarTelaInicial.value
    model.alterarTelaAguarde  = alterarTelaAguarde.value
    model.alterarTelaAbertura = alterarTelaAbertura.value

    model.corTexto = corTexto ??
      model.corTexto ??
      institutionalDraft.value.corTexto ??
      null

    const response = await ApiService.post<any>(
      process.env.VUE_APP_API_CAMPAIGN_ENDPOINT,
      process.env.VUE_APP_API_INSTITUTIONAL_ROUTE_POST_SAVE,
      model.toPayload() // ✅ AGORA IGUAL CAMPANHAS
    );

    const createdId = response?.id;

    institutionalDraft.value.corTexto = model.corTexto

    if (createdId) {
      institutionalDraft.value.id = createdId;
    }

    // ✅ mantém comportamento atual
    if (!isSavingDraft) {
      redeSubredeStore.subredesSelecionadas = [];
    }

    const successMessage = isSavingDraft
      ? 'Rascunho salvo com sucesso.'
      : 'Cadastro institucional criado com sucesso.';

    messages.showSuccessMsg(successMessage);

    await fetchInstitutionalScreens();

    // ✅ atualiza o detail (IMPORTANTE)
    institutionalDetail.value = new TelasInstitucionaisModel(response);

    return createdId;

  } catch (error: any) {
    console.error('❌ Erro ao criar institucional:', error);

    messages.showErrorMsg(
      error?.response?.data?.message ||
      'Erro ao criar cadastro institucional.'
    );

    return null;
  }
};

/*const createInstitutional = async (imagens: any[] = [], telas: any[] = [], exibeTelaAbertura: boolean, isSavingDraft = false) => {
  try {
    const pcStore = usePCStore();
    //const { nome, perfil, dtIniVigencia, dtFimVigencia } = institutionalDraft.value

    
const data =
  institutionalDetail.value || institutionalDraft.value;

const { nome, perfil, dtIniVigencia, dtFimVigencia } = data;


    // ✅ Validação diferente para rascunho vs criação completa
    if (isSavingDraft) {
      // Para salvar rascunho: apenas nome obrigatório
      if (!nome) {
        messages.showErrorMsg('Preencha o campo Nome para salvar.')
        return null
      }
    } else {
      // Para criar completo: todos os campos obrigatórios
      if (!nome || !perfil || !dtIniVigencia) {
        messages.showErrorMsg('Preencha os campos obrigatórios.')
        return null
      }
    }

    const redeSubredeStore = useRedeSubredeStore()

    // ✅ Subredes obrigatórias apenas se não for rascunho
    if (!isSavingDraft && !redeSubredeStore.subredesSelecionadas.length) {
      messages.showErrorMsg('Selecione ao menos uma Subrede.')
      return null
    }

    // ✅ Monta payload de redes (pode estar vazio em rascunho)
    const redesPayload = redeSubredeStore.subredesSelecionadas.map(sr => ({
      codRede: 10, // ✅ Corrigido para rede 10
      codSubrede: sr.codSubredeAutoAtndto
    }))

    // ✅ Monta payload de imagens com URLs do S3
    const imagensPayload = imagens.map(img => ({
      posicaoImagem: img.posicaoImagem,
      urlS3: img.urlS3,
      duracaoImagem: img.duracaoImagem,
      hashImagem: img.hashImagem || null,
      dataCriacao: new Date().toISOString()
    }))

    const payload = {
      nome,
      perfil: perfil || null,
      dtIniVigencia: dtIniVigencia ? formatDateToApi(dtIniVigencia) : null,
      dtFimVigencia: dtFimVigencia ? formatDateToApi(dtFimVigencia) : null,
      versao: 1,
      status: CONST_INSTITUTIONAL_STATUS.DRAFT.id,
      redes: redesPayload.length > 0 ? redesPayload : [],
      pcsIds: pcStore.selectedPCs.map(pc => pc.codpontocaptura),
      imagens: imagensPayload.length > 0 ? imagensPayload : [],
      telasCadastradas: telas,
      exibeTelaAbertura: exibeTelaAbertura 
    }

    console.log('Payload enviado ao backend:', payload)

    const response = await ApiService.post<any>(
      process.env.VUE_APP_API_CAMPAIGN_ENDPOINT,
      process.env.VUE_APP_API_INSTITUTIONAL_ROUTE_POST_SAVE,
      payload
    )

    const createdId = response?.id

    if (createdId) {
      institutionalDraft.value.id = createdId
    }

    // ✅ Limpa subredes selecionadas apenas se não for rascunho
    if (!isSavingDraft) {
      redeSubredeStore.subredesSelecionadas = []
    }

    const successMessage = isSavingDraft 
      ? 'Rascunho salvo com sucesso.' 
      : 'Cadastro institucional criado com sucesso.'
    
    messages.showSuccessMsg(successMessage)

    await fetchInstitutionalScreens()

    return createdId

  } catch (error: any) {
    console.error('❌ Erro ao criar institutional:', error)
    messages.showErrorMsg(
      error?.response?.data?.message ||
      'Erro ao criar cadastro institucional.'
    )
    return null
  }
}*/




  /* =======================
   * EDITAR
   * ======================= */

const editInstitutional = async () => {
  try {
    const detail = institutionalDetail.value;

    if (!detail?.id) {
      throw new Error('ID não encontrado');
    }

    
    const payload = detail.toPayload()
    //const payload = buildInstitutionalPayload(detail); // ✅ BODY

    const responseData = await ApiService.put<any>(
      process.env.VUE_APP_API_CAMPAIGN_ENDPOINT,
      process.env.VUE_APP_API_INSTITUTIONAL_ROUTE_PUT_EDIT,
      payload,
      { id: detail.id } // ✅ vai como param
    );

    // ✅ atualiza o model
    institutionalDetail.value = new TelasInstitucionaisModel(responseData);

    return responseData;

  } catch (error) {
    console.error(error);
    throw error;
  }
};


  const updateInstitutional = async () => {
    try {

      
const detail = institutionalDetail.value;

    if (!detail) {
      throw new Error('Dados não encontrados');
    }

    const payload = buildInstitutionalPayload(detail);


      const response = await ApiService.put<TelasInstitucionaisModel>(
        process.env.VUE_APP_API_CAMPAIGN_ENDPOINT,
        process.env.VUE_APP_API_INSTITUTIONAL_ROUTE_PUT_EDIT,
        payload
      )

      messages.showSuccessMsg('Atualizado com sucesso.')
      await fetchInstitutionalScreens()
      return response

    } catch (error: any) {
      console.error('❌ Erro ao atualizar:', error)
      messages.showErrorMsg('Erro ao atualizar.')
      throw error
    }
  }

  /* =======================
   * AÇÕES - FLUXO DE CRIAÇÃO
   * ======================= */

  /**
   * ✅ ENVIAR PARA APROVAÇÃO (Rascunho/Em Edição → Em Aprovação)
   */
 /*const sendToApproval = async (
  imagens: any[] = [],
  telas: any[] = []
) => {
  try {

    const detail = institutionalDetail.value;

    // ✅ CASO 1: JÁ EXISTE → mantém comportamento atual
    if (detail?.id) {

      const payload = buildInstitutionalPayload(detail);

      const response = await ApiService.post<any>(
        process.env.VUE_APP_API_CAMPAIGN_ENDPOINT,
        process.env.VUE_APP_API_INSTITUTIONAL_ROUTE_POST_SEND_APPROVE,
        payload
      );

      institutionalDetail.value = new TelasInstitucionaisModel(response);

      await fetchInstitutionalScreens();
      return response;
    }

    // ✅ CASO 2: NOVO CADASTRO (igual campanhas)
    const data = institutionalDraft.value;

    // ✅ reaproveita regra existente
    const payload = {
      nome: data.nome,
      perfil: data.perfil || null,
      dtIniVigencia: data.dtIniVigencia
        ? formatDateToApi(data.dtIniVigencia)
        : null,
      dtFimVigencia: data.dtFimVigencia
        ? formatDateToApi(data.dtFimVigencia)
        : null,
      versao: 1,
      status: CONST_INSTITUTIONAL_STATUS.ON_APPROVAL.id,

      imagens: imagens || [],
      telasCadastradas: telas,

      // ✅ mesma regra que você já usa
      exibeTelaAbertura: telas?.find(t => t.tipoTela === 'ABERTURA')
        ?.apresentaParaCliente ?? false
    };

    const response = await ApiService.post<any>(
      process.env.VUE_APP_API_CAMPAIGN_ENDPOINT,
      process.env.VUE_APP_API_INSTITUTIONAL_ROUTE_POST_SEND_APPROVE,
      payload
    );

    institutionalDetail.value = new TelasInstitucionaisModel(response);

    await fetchInstitutionalScreens();
    return response;

  } catch (error: any) {
    console.error('Erro ao enviar para aprovação:', error);
    messages.showErrorMsg('Erro ao enviar para aprovação.');
    throw error;
  }
};*/

const sendToApproval = async (
  imagens: any[] = [],
  telas: any[] = [],
  exibeTelaAbertura: boolean
) => {
  try {

    const pcStore = usePCStore();
    const redeSubredeStore = useRedeSubredeStore();

    let model = institutionalDetail.value;

    // ✅ novo cadastro → cria model
    if (!model) {
      model = new TelasInstitucionaisModel({
        ...institutionalDraft.value,
        versao: 1
      });
    }

    // ✅ popula model (igual campanhas faz)
    model.imagens = imagens;

    model.telasCadastradas = telas;

    model.exibeTelaAbertura = exibeTelaAbertura

   model.redes = redeSubredeStore.subredesSelecionadas.length
  ? redeSubredeStore.subredesSelecionadas.map(sr => ({
      codRede: 10,
      codSubrede: sr.codSubredeAutoAtndto
    }))
  : institutionalDetail?.value?.redes || [] // ✅ fallback para redes já salvas


    //model.pcsIds = pcStore.selectedPCs.map(pc => pc.codpontocaptura);

    model.pcsIds = pcStore.selectedPCs.length
  ? pcStore.selectedPCs.map(pc => pc.codpontocaptura)
  : model.pcsIds || []

    model.status = CONST_INSTITUTIONAL_STATUS.ON_APPROVAL.id;

    model.corTexto =
      model.corTexto ??
      institutionalDraft.value.corTexto ??
      null

    model.alterarTelaInicial  = alterarTelaInicial.value
    model.alterarTelaAguarde  = alterarTelaAguarde.value
    model.alterarTelaAbertura = alterarTelaAbertura.value

    const response = await ApiService.post<any>(
      process.env.VUE_APP_API_CAMPAIGN_ENDPOINT,
      process.env.VUE_APP_API_INSTITUTIONAL_ROUTE_POST_SEND_APPROVE,
      model.toPayload()
    );

    institutionalDetail.value = new TelasInstitucionaisModel(response);

    await fetchInstitutionalScreens();

    return response;

  } catch (error: any) {
    console.error(error);
    messages.showErrorMsg('Erro ao enviar para aprovação.');
    throw error;
  }
};

  /**
   * ✅ APROVAR (Em Aprovação → Aprovado)
   */
  const approveInstitutional = async (id: number) => {
    try {
      const response = await ApiService.put<any>(
        process.env.VUE_APP_API_CAMPAIGN_ENDPOINT,
        `${process.env.VUE_APP_API_INSTITUTIONAL_ROUTE_PUT_APPROVE}?id=${id}`,
        {}
      )

      institutionalDetail.value = new TelasInstitucionaisModel(response)
      await fetchInstitutionalScreens()

      return response
    } catch (error) {
      console.error('❌ Erro ao aprovar:', error)
      throw error
    }
  }

  /**
   * ✅ SOLICITAR AJUSTES (Em Aprovação → Solicitado Ajuste)
   */
 const requestAdjustments = async (id: number, comentarioAjuste: string) => {
  try {
    const pcStore = usePCStore()
    const redeSubredeStore = useRedeSubredeStore()

    const model = institutionalDetail.value
    if (!model) throw new Error('Dados não encontrados')

    // ✅ preserva todos os dados + adiciona comentário
    model.imagens = imagensDraft.value.length ? imagensDraft.value : model.imagens
    model.telasCadastradas = telasDraft.value.length ? telasDraft.value : model.telasCadastradas
    model.exibeTelaAbertura = exibeTelaAberturaRascunho.value !== false
      ? exibeTelaAberturaRascunho.value
      : model.exibeTelaAbertura ?? false
    model.redes = redeSubredeStore.subredesSelecionadas.length
      ? redeSubredeStore.subredesSelecionadas.map(sr => ({ codRede: 10, codSubrede: sr.codSubredeAutoAtndto }))
      : model.redes || []
    model.pcsIds = pcStore.selectedPCs.length
      ? pcStore.selectedPCs.map(pc => pc.codpontocaptura)
      : model.pcsIds || []
    model.comentarioAjuste = comentarioAjuste // ✅ adiciona comentário

    model.alterarTelaInicial  = alterarTelaInicial.value
    model.alterarTelaAguarde  = alterarTelaAguarde.value
    model.alterarTelaAbertura = alterarTelaAbertura.value

    const response = await ApiService.put<any>(
      process.env.VUE_APP_API_CAMPAIGN_ENDPOINT,
      process.env.VUE_APP_API_INSTITUTIONAL_ROUTE_PUT_REQUEST_ADJUST,
      model.toPayload(), // ✅ body completo com comentário
      { id }            // ✅ query param
    )

    institutionalDetail.value = new TelasInstitucionaisModel(response)
    await fetchInstitutionalScreens()
    return response

  } catch (error: any) {
    console.error('❌ Erro ao solicitar ajustes:', error)
    messages.showErrorMsg('Erro ao solicitar ajustes.')
    throw error
  }
}

  /**
   * ✅ PUBLICAR (Aprovado → Cadastro Publicado)
   */
  const publishInstitutional = async (id: number) => {
    try {
      const response = await ApiService.put<any>(

         process.env.VUE_APP_API_CAMPAIGN_ENDPOINT,       
       `${process.env.VUE_APP_API_INSTITUTIONAL_ROUTE_PUT_PUBLISH}?id=${id}`,
        {}
      )
     
      institutionalDetail.value = new TelasInstitucionaisModel(response)
      // await fetchInstitutionalScreens()
      //return response
    } catch (error: any) {
      console.error('❌ Erro ao publicar:', error)
      messages.showErrorMsg('Erro ao publicar cadastro.')
      throw error
    }
  }

  
/*const fetchPcsDistribuicao = async (telaId: number, page = 0, size = 100) => {
  const response = await ApiService.get<any>(   
    process.env.VUE_APP_API_CAMPAIGN_ENDPOINT,
    process.env.VUE_APP_API_INSTITUCIONAL_ROUTE_GET_DISTRIBUICAO,
    { telaId, page, size }

  );

  return response;
};*/

const distribuicao = ref<any>({
  pcsTela: [],
  currentPcPage: 0,
  totalPcPages: 0,
  totalPcs: 0,
  totalSucesso: 0,
  totalPendentes: 0,
  ultimaAtualizacao: null,
  telaId: null
})

const fetchPcsDistribuicao = async (
  telaId: number,
  pageNumber?: number | null
) => {
  try {

    const responseData = await ApiService.get<any>(
      process.env.VUE_APP_API_CAMPAIGN_ENDPOINT,
      process.env.VUE_APP_API_INSTITUCIONAL_ROUTE_GET_DISTRIBUICAO,
      { telaId, page: pageNumber ?? 0 }
    )

    if (pageNumber == null) {
      pageNumber = 0
    }

    if (!responseData) {
      distribuicao.value = {
        pcsTela: []
      }
      return
    }

    // ✅ pega estado anterior corretamente
    const lastPage =
      distribuicao.value?.pcsTela &&
      distribuicao.value?.telaId === telaId
        ? [...distribuicao.value.pcsTela]
        : []

    // ✅ monta NOVO objeto completo
    const novaDistribuicao = {
      ...responseData,
      pcsTela:
        pageNumber === 0
          ? [...(responseData.pcsTela || [])] // primeira página
          : [...lastPage, ...(responseData.pcsTela || [])] // acumula
    }

    // ✅ só aqui atualiza o estado
    distribuicao.value = novaDistribuicao

  } catch (error) {
    console.error(error)
  }
}


/*const fetchPcsByTela = async (telaId: number) => {
  const response = await ApiService.get<any>(
    process.env.VUE_APP_API_CAMPAIGN_ENDPOINT,
    process.env.VUE_APP_API_INSTITUCIONAL_ROUTE_GET_PCS_ASSOCIADOS,
    { telaId }
  );

  return response;
};*/

const fetchPcsByTela = async (telaId: number, download = false) => {
  const response = await ApiService.get<any>(
    process.env.VUE_APP_API_CAMPAIGN_ENDPOINT,
    process.env.VUE_APP_API_INSTITUCIONAL_ROUTE_GET_PCS_ASSOCIADOS,
    {
      telaId,
      download
    }
  )

  return response
}



const axiosClean = axios.create() // ✅ SEM interceptor



const downloadPcsByTela = async (telaId: number, grupo?: string) => {
  const base = process.env.VUE_APP_API_CAMPAIGN_ENDPOINT
  const route = process.env.VUE_APP_API_INSTITUCIONAL_ROUTE_GET_PCS_ASSOCIADOS

  const url = `${base.replace(/\/$/, '')}/${route.replace(/^\//, '')}`

  try {
    const response = await axios.get(url, {
      params: {
        telaId,
        download: true,
        grupo
      },
      responseType: 'blob',
      headers: {
        // ✅ reaproveita exatamente como ApiService faz
        Authorization: `Bearer ${localStorage.getItem("token")}`
      }
    })

    const blob = new Blob([response.data], { type: 'text/csv' })
    const downloadUrl = window.URL.createObjectURL(blob)

    const link = document.createElement('a')
    link.href = downloadUrl
    
    link.download = grupo ? `pcs_${grupo}.csv` : 'pcs.csv'

   // link.download = 'pcs.csv'
    document.body.appendChild(link)
    link.click()
    document.body.removeChild(link)

    window.URL.revokeObjectURL(downloadUrl)

  } catch (error) {
    console.error('Erro ao baixar CSV', error)
  }
}








  /**
   * ✅ CANCELAR (Pode ser feito em vários status)
   */
const cancelInstitutional = async (id: number) => {
  try {
    const response = await ApiService.put<any>(
      process.env.VUE_APP_API_CAMPAIGN_ENDPOINT,
      `${process.env.VUE_APP_API_INSTITUTIONAL_ROUTE_PUT_CANCEL}?id=${id}`,
      {}
    )
    await fetchInstitutionalScreens()
    return response
  } catch (error: any) {
    console.error('❌ Erro ao cancelar:', error)
    messages.showErrorMsg('Erro ao cancelar cadastro.')
    throw error
  }
}



 const uploadImagens = async (imagensDraft: any[]) => {
  const imagensNovas = imagensDraft.filter(img => img.file)
  const imagensExistentes = imagensDraft.filter(img => !img.file && img.urlS3)

  if (!imagensNovas.length && !imagensExistentes.length) {
    throw new Error('Nenhuma imagem configurada')
  }

  let imagensUpadas: any[] = []

  if (imagensNovas.length > 0) {
    const formData = new FormData()
    const posicoes: number[] = []

    imagensNovas.forEach(img => {
      formData.append('images', img.file)
      posicoes.push(img.posicaoImagem)
    })

    // ✅ Igual campanhas — usa ApiService com headers corretos (token incluso)
    const additionalHeaders = {
      'Content-Type': 'multipart/form-data'
    }

    const resultado = await ApiService.post<any>(
      process.env.VUE_APP_API_PACKAGE_ENDPOINT,
      process.env.VUE_APP_API_UPLOAD_TELAS_ROUTE,
      formData,
      additionalHeaders
    )

    if (!resultado.success) {
      throw new Error(resultado.error || 'Erro ao fazer upload')
    }

    imagensUpadas = resultado.uploadLocations.map((item: any, index: number) => ({
      posicaoImagem: posicoes[index],
      urlS3: item.url,
      duracaoImagem: imagensNovas[index].duracaoImagem ?? 5,
      hashImagem: imagensNovas[index].hashImagem || null
    }))
  }

  const todasImagens = [
    ...imagensExistentes.map(img => ({
      posicaoImagem: img.posicaoImagem,
      urlS3: img.urlS3,
      duracaoImagem: img.duracaoImagem ?? 5,
      hashImagem: img.hashImagem || null
    })),
    ...imagensUpadas
  ]

  return todasImagens.sort((a, b) => a.posicaoImagem - b.posicaoImagem)
}



  /* =======================
   * AÇÕES - FLUXO DE ALTERAÇÃO (REEDIÇÃO)
   * ======================= */

  /**
   * ✅ REENVIAR PARA APROVAÇÃO (Solicitado Ajuste → Em Aprovação)
   */
 const resendToApproval = async (
  id: number,
  imagens: any[] = [],
  telas: any[] = [],
  exibeTelaAbertura: boolean
) => {
  try {
    const pcStore = usePCStore()
    const redeSubredeStore = useRedeSubredeStore()

    const model = institutionalDetail.value
    if (!model) throw new Error('Dados não encontrados')

    model.imagens = imagens.length ? imagens : model.imagens
    model.telasCadastradas = telas.length ? telas : model.telasCadastradas
    model.exibeTelaAbertura = exibeTelaAbertura
    model.redes = redeSubredeStore.subredesSelecionadas.length
      ? redeSubredeStore.subredesSelecionadas.map(sr => ({ codRede: 10, codSubrede: sr.codSubredeAutoAtndto }))
      : model.redes || []
   /* model.pcsIds = pcStore.selectedPCs.length
      ? pcStore.selectedPCs.map(pc => pc.codpontocaptura)
      : model.pcsIds || []*/
      model.pcsIds = pcStore.selectedPCs.length
  ? pcStore.selectedPCs.map(pc => pc.codpontocaptura)
  : []
    model.status = CONST_INSTITUTIONAL_STATUS.ON_APPROVAL.id

    model.alterarTelaInicial  = alterarTelaInicial.value
    model.alterarTelaAguarde  = alterarTelaAguarde.value
    model.alterarTelaAbertura = alterarTelaAbertura.value

    const response = await ApiService.put<any>(
      process.env.VUE_APP_API_CAMPAIGN_ENDPOINT,
      process.env.VUE_APP_API_INSTITUTIONAL_ROUTE_PUT_RESEND_APPROVAL,
      model.toPayload(), // ✅ body
      { id }            // ✅ query param — igual editInstitutional faz
    )

    institutionalDetail.value = new TelasInstitucionaisModel(response)
    await fetchInstitutionalScreens()
    return response

  } catch (error: any) {
    console.error('❌ Erro ao reenviar para aprovação:', error)
    messages.showErrorMsg('Erro ao reenviar para aprovação.')
    throw error
  }
}

  /**
   * ✅ ENVIAR PARA REEDIÇÃO (Cadastro Publicado/Ativo → Em Reedição)
   */
  const sendToReissue = async (id: number) => {
    try {
      const response = await ApiService.put<any>(
        process.env.VUE_APP_API_CAMPAIGN_ENDPOINT,
        process.env.VUE_APP_API_INSTITUTIONAL_ROUTE_PUT_REISSUE,
        { id }
      )
      await fetchInstitutionalScreens()
      return response
    } catch (error: any) {
      console.error('❌ Erro ao enviar para reedição:', error)
      messages.showErrorMsg('Erro ao enviar para reedição.')
      throw error
    }
  }

  /**
   * ✅ ENVIAR PARA REAPROVAÇÃO (Em Reedição → Em Reaprovação)
   */
 /*const sendToReapproval = async (id: number, imagens: any[] = [], telas: any[] = [], exibeTelaAbertura: boolean) => {
  try {
    const pcStore = usePCStore()
    const redeSubredeStore = useRedeSubredeStore()

    const model = institutionalDetail.value
    if (!model) throw new Error('Dados não encontrados')

  
    let imagensFinais: any[] = imagens.length ? imagens : []

    if (!imagensFinais.length && imagensDraft.value.length) {
      const temImagemNova = imagensDraft.value.some(img => img.file)

      if (temImagemNova) {
        imagensFinais = await uploadImagens(imagensDraft.value)
      } else {
        imagensFinais = imagensDraft.value.map(img => ({
          posicaoImagem: img.posicaoImagem,
          urlS3: img.urlS3,
          duracaoImagem: img.duracaoImagem ?? 10
        }))
      }
    } else if (!imagensFinais.length) {
      imagensFinais = (model.imagens || []).map(img => ({
        posicaoImagem: img.posicaoImagem,
        urlS3: img.urlS3,
        duracaoImagem: img.duracaoImagem ?? 10
      }))
    }

   
    //const telasFinais = telas.length ? telas : (telasDraft.value.length ? telasDraft.value : model.telasCadastradas || [])

    const telasFinais = telas && telas.length > 0 ? telas : (telasDraft.value.length ? telasDraft.value : model.telasCadastradas || [])
   

    const exibeTelaAberturaFinal = exibeTelaAbertura !== undefined 
      ? exibeTelaAbertura 
      : (exibeTelaAberturaRascunho.value !== false ? exibeTelaAberturaRascunho.value : model.exibeTelaAbertura ?? false)

    const redes = redeSubredeStore.subredesSelecionadas.length
      ? redeSubredeStore.subredesSelecionadas.map(sr => ({
          codRede: 10,
          codSubrede: sr.codSubredeAutoAtndto
        }))
      : model.redes || []


    const pcsIds = pcStore.selectedPCs.length
      ? pcStore.selectedPCs.map(pc => pc.codpontocaptura)
      : model.pcsIds || []

 
    model.status = CONST_INSTITUTIONAL_STATUS.ON_RE_APPROVAL.id

 
    model.imagens = imagensFinais
    model.telasCadastradas = telasFinais
    model.exibeTelaAbertura = exibeTelaAberturaFinal
    model.redes = redes
    model.pcsIds = pcsIds

    model.alterarTelaInicial  = alterarTelaInicial.value
    model.alterarTelaAguarde  = alterarTelaAguarde.value
    model.alterarTelaAbertura = alterarTelaAbertura.value

    const response = await ApiService.put<any>(
      process.env.VUE_APP_API_CAMPAIGN_ENDPOINT,
      process.env.VUE_APP_API_INSTITUTIONAL_ROUTE_PUT_SEND_REAPPROVAL,
      model.toPayload(),
      { id }
    )

    institutionalDetail.value = new TelasInstitucionaisModel(response)

    await fetchInstitutionalScreens()

    return response

  } catch (error: any) {
    console.error('❌ Erro ao enviar para reaprovação:', error)
    messages.showErrorMsg('Erro ao enviar para reaprovação.')
    throw error
  }
}*/


const sendToReapproval = async (
  id: number,
  imagens: any[] = [],
  telas: any[] = [],
  exibeTelaAbertura: boolean
) => {
  try {
    const pcStore = usePCStore()
    const redeSubredeStore = useRedeSubredeStore()

    const model = institutionalDetail.value
    if (!model) throw new Error('Dados não encontrados')

    model.imagens = imagens.length ? imagens : model.imagens
    model.telasCadastradas = telas.length ? telas : model.telasCadastradas
    model.exibeTelaAbertura = exibeTelaAbertura
    model.redes = redeSubredeStore.subredesSelecionadas.length
      ? redeSubredeStore.subredesSelecionadas.map(sr => ({ codRede: 10, codSubrede: sr.codSubredeAutoAtndto }))
      : model.redes || []
   /* model.pcsIds = pcStore.selectedPCs.length
      ? pcStore.selectedPCs.map(pc => pc.codpontocaptura)
      : model.pcsIds || []*/
      model.pcsIds = pcStore.selectedPCs.length
  ? pcStore.selectedPCs.map(pc => pc.codpontocaptura)
  : []
    model.status = CONST_INSTITUTIONAL_STATUS.ON_RE_APPROVAL.id

    model.alterarTelaInicial  = alterarTelaInicial.value
    model.alterarTelaAguarde  = alterarTelaAguarde.value
    model.alterarTelaAbertura = alterarTelaAbertura.value

    const response = await ApiService.put<any>(
      process.env.VUE_APP_API_CAMPAIGN_ENDPOINT,
      process.env.VUE_APP_API_INSTITUTIONAL_ROUTE_PUT_SEND_REAPPROVAL,
      model.toPayload(), // ✅ body
      { id }            // ✅ query param — igual editInstitutional faz
    )

    institutionalDetail.value = new TelasInstitucionaisModel(response)
    await fetchInstitutionalScreens()
    return response

  } catch (error: any) {
    console.error('❌ Erro ao enviar para reaprovação:', error)
    messages.showErrorMsg('Erro ao enviar para reaprovação.')
    throw error
  }
 
}


// ✅ REAPROVAR — igual aprovar
const reapproveInstitutional = async (id: number) => {
  try {
    const response = await ApiService.put<any>(
      process.env.VUE_APP_API_CAMPAIGN_ENDPOINT,
      `${process.env.VUE_APP_API_INSTITUTIONAL_ROUTE_PUT_REAPPROVE}?id=${id}`,
      {}
    )

    institutionalDetail.value = new TelasInstitucionaisModel(response) // ✅ ADICIONA

    await fetchInstitutionalScreens()
    return response
  } catch (error: any) {
    console.error('❌ Erro ao reaprovar:', error)
    messages.showErrorMsg('Erro ao reaprovar cadastro.')
    throw error
  }
}


  /**
   * ✅ SOLICITAR REAJUSTE (Em Reaprovação → Solicitado Reajuste)
   */
  const requestReadjustments = async (id: number, comentarioAjuste: string) => {
  try {
    const pcStore = usePCStore()
    const redeSubredeStore = useRedeSubredeStore()

    const model = institutionalDetail.value
    if (!model) throw new Error('Dados não encontrados')

    // ✅ mesmo padrão do requestAdjustments — preserva todos os dados
    model.imagens = imagensDraft.value.length ? imagensDraft.value : model.imagens
    model.telasCadastradas = telasDraft.value.length ? telasDraft.value : model.telasCadastradas
    model.exibeTelaAbertura = exibeTelaAberturaRascunho.value !== false
      ? exibeTelaAberturaRascunho.value
      : model.exibeTelaAbertura ?? false
    model.redes = redeSubredeStore.subredesSelecionadas.length
      ? redeSubredeStore.subredesSelecionadas.map(sr => ({ codRede: 10, codSubrede: sr.codSubredeAutoAtndto }))
      : model.redes || []
    model.pcsIds = pcStore.selectedPCs.length
      ? pcStore.selectedPCs.map(pc => pc.codpontocaptura)
      : model.pcsIds || []
    model.comentarioAjuste = comentarioAjuste // ✅ adiciona comentário de reajuste

    model.alterarTelaInicial  = alterarTelaInicial.value
    model.alterarTelaAguarde  = alterarTelaAguarde.value
    model.alterarTelaAbertura = alterarTelaAbertura.value

    const response = await ApiService.put<any>(
      process.env.VUE_APP_API_CAMPAIGN_ENDPOINT,
      process.env.VUE_APP_API_INSTITUTIONAL_ROUTE_PUT_REQUEST_READJUST,
      model.toPayload(), // ✅ body completo com comentário
      { id }            // ✅ query param
    )

    await fetchInstitutionalScreens()
    return response

  } catch (error: any) {
    console.error('❌ Erro ao solicitar reajuste:', error)
    messages.showErrorMsg('Erro ao solicitar reajuste.')
    throw error
  }
}


 // ✅ REPUBLICAR — igual publicar, query param na URL
// const republishInstitutional = async (id: number) => {
//   try {
//     const response = await ApiService.put<any>(
//       process.env.VUE_APP_API_CAMPAIGN_ENDPOINT,
//       `${process.env.VUE_APP_API_INSTITUTIONAL_ROUTE_PUT_REPUBLISH}?id=${id}`,
//       {}
//     )
//     await fetchInstitutionalScreens()
//     return response
//   } catch (error: any) {
//     console.error('❌ Erro ao republicar:', error)
//     messages.showErrorMsg('Erro ao republicar cadastro.')
//     throw error
//   }
// }
const republishInstitutional = async (id: number) => {
  try {
    const response = await ApiService.put<any>(
      process.env.VUE_APP_API_CAMPAIGN_ENDPOINT,
      `${process.env.VUE_APP_API_INSTITUTIONAL_ROUTE_PUT_REPUBLISH}?id=${id}`,
      {}
    )
    institutionalDetail.value = new TelasInstitucionaisModel(response)
    await fetchInstitutionalScreens()
    return response
  } catch (error: any) {
    console.error('❌ Erro ao republicar:', error)
    messages.showErrorMsg('Erro ao republicar cadastro.')
    throw error
  }
}


  // ✅ DESCARTAR ALTERAÇÕES — só query param, sem body
const discardChanges = async (id: number) => {
  try {
    const response = await ApiService.put<any>(
      process.env.VUE_APP_API_CAMPAIGN_ENDPOINT,
      `${process.env.VUE_APP_API_INSTITUTIONAL_ROUTE_PUT_DISCARD_CHANGES}?id=${id}`,
      {}
    )
    await fetchInstitutionalScreens()
    return response
  } catch (error: any) {
    console.error('❌ Erro ao descartar alterações:', error)
    messages.showErrorMsg('Erro ao descartar alterações.')
    throw error
  }
}

  /* =======================
   * EXCLUSÃO
   * ======================= */

  const deleteInstitutionals = async (ids: number[]) => {
    try {
      await ApiService.put(
        process.env.VUE_APP_API_CAMPAIGN_ENDPOINT,
        process.env.VUE_APP_API_INSTITUTIONAL_ROUTE_DELETE,
        null,
        { ids }
      )
      await fetchInstitutionalScreens()
    } catch (error: any) {
      console.error('❌ Erro ao deletar:', error)
      messages.showErrorMsg('Erro ao deletar cadastros.')
      throw error
    }
  }

  const canDeleteSelectedInstitutionals = () =>
  selectedInstitutionals.value.every(item =>
    [
      CONST_INSTITUTIONAL_STATUS.DRAFT.id,
      CONST_INSTITUTIONAL_STATUS.CANCELED.id,
      CONST_INSTITUTIONAL_STATUS.INSTITUTIONAL_COMPLETED.id,
      CONST_INSTITUTIONAL_STATUS.HISTORICO.id,  
    ].includes(Number(item.status)) // ✅ converte para number
  )


  const resetInstitutionalFilter = () => {
    institutionalFilter.value = {}
  }

  const resetState = () => {
  institutionalScreens.value.length = 0
  selectedInstitutionals.value.length = 0
  institutionalDetail.value = null
  institutionalDraft.value = {
    nome: '',
    perfil: null,
    dtIniVigencia: '',
    dtFimVigencia: ''
  }
  imagensDraft.value = []
  telasDraft.value = []
  exibeTelaAberturaRascunho.value = true
  //alterarTelaInicial = false
  //alterarTelaAguarde = false
  //alterarTelaAbertura = true
  institutionalFilter.value = {}
  reviewData.value = null
}



  const getAvailableActions = (status: number) => {
     const statusNumber = Number(status);
    return {
      canEdit: [
        CONST_INSTITUTIONAL_STATUS.DRAFT.id,
        CONST_INSTITUTIONAL_STATUS.ON_EDITING.id,
        CONST_INSTITUTIONAL_STATUS.ADJUSTMENT_REQUESTED.id,
        CONST_INSTITUTIONAL_STATUS.APPROVED.id
      ].includes(status),

      canCancel: [
        CONST_INSTITUTIONAL_STATUS.DRAFT.id,
        CONST_INSTITUTIONAL_STATUS.ON_EDITING.id,
        CONST_INSTITUTIONAL_STATUS.ADJUSTMENT_REQUESTED.id,
        CONST_INSTITUTIONAL_STATUS.APPROVED.id,
        CONST_INSTITUTIONAL_STATUS.PENDING_PUBLICATION.id,
        CONST_INSTITUTIONAL_STATUS.PUBLISHED.id,
        CONST_INSTITUTIONAL_STATUS.ACTIVE_INSTITUTIONAL.id
      ].includes(status),

      canSendToApproval: [
        CONST_INSTITUTIONAL_STATUS.DRAFT.id,
        CONST_INSTITUTIONAL_STATUS.ON_EDITING.id
      ].includes(status),

      canResendToApproval: [
        CONST_INSTITUTIONAL_STATUS.ADJUSTMENT_REQUESTED.id
      ].includes(status),

      canApprove: [
        CONST_INSTITUTIONAL_STATUS.ON_APPROVAL.id
      ].includes(status),

      canRequestAdjustment: [
        CONST_INSTITUTIONAL_STATUS.ON_APPROVAL.id
      ].includes(status),

      canPublish: [
        CONST_INSTITUTIONAL_STATUS.APPROVED.id
      ].includes(status),

      canReissue: [
        CONST_INSTITUTIONAL_STATUS.PUBLISHED.id,
        CONST_INSTITUTIONAL_STATUS.ACTIVE_INSTITUTIONAL.id
      ].includes(status),

      canSendToReapproval: [
        CONST_INSTITUTIONAL_STATUS.ON_REISSUE.id
      ].includes(status),

      canReapprove: [
        CONST_INSTITUTIONAL_STATUS.ON_RE_APPROVAL.id
      ].includes(status),

      canRequestReadjustment: [
        CONST_INSTITUTIONAL_STATUS.ON_RE_APPROVAL.id
      ].includes(status),

      canRepublish: [
        CONST_INSTITUTIONAL_STATUS.REAPPROVED.id
      ].includes(status),

      canDiscardChanges: [
        CONST_INSTITUTIONAL_STATUS.ON_REISSUE.id,
        CONST_INSTITUTIONAL_STATUS.REAPPROVED.id,
        CONST_INSTITUTIONAL_STATUS.ADJUSTMENT_REQUESTED_AGAIN.id
      ].includes(status)
    }
  }

  
const reviewData = ref<any>(null);

function setReviewData(data: any) {
  reviewData.value = data;
}


const imagensDraft = ref<any[]>([])

const clearReviewData = () => {
  reviewData.value = null
}

const setImagensDraft = (imgs: any[]) => {
  imagensDraft.value = imgs;
};

const telasDraft = ref<any[]>([])

const setTelasDraft = (telas: any[]) => {
  telasDraft.value = telas
}

const exibeTelaAberturaRascunho = ref<boolean>(true)

const setExibeTelaAbertura = (value: boolean) => {
  exibeTelaAberturaRascunho.value = value
}


const validateFocusedInstitutionalFields = (imagens: any[] = [], alterarTelaAbertura: string) => {
  try {
    let isValid = true;
    const messagesArray: string[] = [];
    const redeSubredeStore = useRedeSubredeStore();

    const d = institutionalDetail.value || institutionalDraft.value;

    if (!d?.nome) {
      messagesArray.push('Favor preencher o Nome');
    }

    if (!d.perfil) {
      messagesArray.push('Favor selecionar o Perfil');
    }

    if (!d.dtIniVigencia) {
      messagesArray.push('Favor informar a Data de Início');
    } else {
      // ✅ Valida se a data é retroativa (suporta DD/MM/YYYY e YYYY-MM-DD)
      let dtIni: Date;

      if (d.dtIniVigencia.includes('/')) {
        const [day, month, year] = d.dtIniVigencia.split('/');
        dtIni = new Date(`${year}-${month}-${day}`);
      } else {
        dtIni = new Date(d.dtIniVigencia);
      }

      const hoje = new Date();
      hoje.setHours(0, 0, 0, 0);
      dtIni.setHours(0, 0, 0, 0);

      if (dtIni < hoje) {
        messagesArray.push('A Data de Início deve ser maior que a data atual');
      }
    }

    // ✅ Valida rede/subrede
    if (!redeSubredeStore.subredesSelecionadas.length) {
      messagesArray.push('Favor selecionar ao menos uma Rede/Subrede');
    }

    // ✅ usa o parâmetro recebido, não o imagensDraft do store
   /* if (!imagens.length) {
      messagesArray.push('Favor adicionar ao menos uma imagem');
    }*/

    if (messagesArray.length > 0) {
      isValid = false;
      messagesArray.reverse().forEach(m => {
        messages.showWarningMsg(m);
      });
    }

    return isValid;

  } catch (error) {
    console.error(error);
    return false;
  }
};

  const veioDaReview = ref(false)

  const setVeioDaReview = (value: boolean) => {
    veioDaReview.value = value
  }


  return {
    institutionalScreens,
    institutionalDetail,
    institutionalDraft,
    selectedInstitutionals,
    institutionalFilter,
    loading,
    reviewData,
    setReviewData,    
    clearReviewData,
    validateFocusedInstitutionalFields,
    imagensDraft,
    setImagensDraft,
    fetchPcsDistribuicao,
    fetchPcsByTela,
    uploadImagens,
    exibeTelaAberturaRascunho,
    setExibeTelaAbertura,
    telasDraft,
    setTelasDraft,
    fetchPcsByIds,
    resetState,
    alterarTelaInicial,
    alterarTelaAguarde,

    fetchInstitutionalScreens,
    fetchInstitutionalById,
    createInstitutional,
    updateInstitutional,
    editInstitutional,
    distribuicao,

    sendToApproval,
    approveInstitutional,
    requestAdjustments,
    publishInstitutional,
    cancelInstitutional,

    resendToApproval,
    sendToReissue,
    sendToReapproval,
    reapproveInstitutional,
    requestReadjustments,
    republishInstitutional,
    discardChanges,
    downloadPcsByTela,

    deleteInstitutionals,
    resetInstitutionalFilter,
    canDeleteSelectedInstitutionals,
    getAvailableActions,
    veioDaReview,
    setVeioDaReview
  }
})

